import CacheUtil from '../../common/utils/CacheUtil'
import loan from './testData/loan'

describe('CacheUtil', () => {
  describe('findEntityInQuery', () => {
    it('should return a copy of the given entity (Business) from the given query', () => {
      const [entity] = loan.businesses
      const foundEntity = CacheUtil.findEntityInQuery(entity, { loan })
      expect(entity.rid).toEqual(foundEntity.rid)
    })
    it('should return a copy of the given entity (Guarantor) from the given query', () => {
      const entity = loan.businesses[0].guarantors[0]
      const foundEntity = CacheUtil.findEntityInQuery(entity, { loan })
      expect(entity.rid).toEqual(foundEntity.rid)
    })
  })
  describe('findAffiliateEntityById', () => {
    it('should return a copy of the given entity (Business) from the given query', () => {
      const entity = loan.affiliates[0]
      const foundEntity = CacheUtil.findAffiliateEntityById(loan, entity.rid)
      expect(entity.rid).toEqual(foundEntity.rid)
    })
  })
  describe('getEntities', () => {
    it('should return a list of all the entities on the loan', () => {
      const entities = loan.businesses.concat(loan.businesses[0].guarantors)
      const foundEntities = CacheUtil.getEntities(loan)
      for (const entity of entities) {
        expect(foundEntities.findIndex(e => e.rid === entity.rid)).toBeGreaterThan(-1)
      }
    })
  })
  describe('replaceCashflowDatum', () => {
    it('should replace a cashflow datum on an entity with year and category that match the given datum', () => {
      const entity = JSON.parse(JSON.stringify(loan.businesses[0]))
      // Datum's original value is 936. We will replace it with 200
      const datum = {
        source: 'manual_document',
        period: null,
        category: 'opex',
        year: 2018,
        data: 200,
        days: 365,
        reason: null,
        resourceType: 'Business',
        createdAt: 1534099708,
        accountable: {
          name: 'Super User',
          __typename: 'Administrator'
        },
        __typename: 'CashflowDatum'
      }
      // const oldDatum = JSON.parse(
      //   JSON.stringify(
      //     loan.businesses[0].cashflowData.find(d => d.year === datum.year && d.category === datum.category)
      //   )
      // )
      CacheUtil.replaceCashflowDatum(datum, entity)
      const newDatum = entity.cashflowData.find(d => d.year === datum.year &&  d.category === datum.category)
      expect(newDatum.data).toEqual(datum.data)
    })
    it('should add a new datum to an entity\'s cashflow data if it can\'t find one to replace', () => {
      const entity = JSON.parse(JSON.stringify(loan.businesses[0].guarantors[0]))
      // Datum's original value is 33535, we will replace it with 1000
      const datum = {
        source: 'manual_document',
        period: null,
        category: 'pensions_and_annuities',
        year: 2016,
        data: 1000,
        days: 365,
        reason: null,
        resourceType: 'Guarantor',
        createdAt: 1534130554,
        accountable: {
          name: 'Super User',
          __typename: 'Administrator'
        },
        __typename: 'CashflowDatum'
      }
      CacheUtil.replaceCashflowDatum(datum, entity)
      const newDatum = entity.cashflowData.find(d => d.year === datum.year && d.category === datum.category)
      expect(newDatum.data).toEqual(datum.data)
    })
  })
  describe('removeCashflowDatum', () => {
    it('should remove a cashflow datum with the specified year, source, and category', () => {
      const entity = JSON.parse(JSON.stringify(loan.businesses[0]))
      const originalDatum = {
        source: 'manual_document',
        period: null,
        category: 'interest_expense',
        year: 2017,
        data: 534567,
        days: 365,
        reason: null,
        resourceType: 'Business',
        createdAt: 1534144486,
        accountable: {
          name: 'Super User',
          __typename: 'Administrator'
        },
        __typename: 'CashflowDatum'
      }
      const dataKey = { year: originalDatum.year, source: originalDatum.source, category: originalDatum.category }
      CacheUtil.removeCashflowDatum(dataKey, entity)
      expect(entity.cashflowData.findIndex(d => d.year === originalDatum.year && d.source === originalDatum.source && d.category === originalDatum.category)).toEqual(-1)
    })
  })
  describe('findOC', () => {
    it('should find the OC in the given loan', () => {
      const oc = loan.businesses.find(b => b.borrowerType === 'oc')
      expect(CacheUtil.findOC(loan).rid).toBe(oc.rid)
    })
  })
  describe('removeCashflowDataByYear', () => {
    it('should remove all of an entity\'s cashflow data for the specified year', () => {
      const entity = JSON.parse(JSON.stringify(loan.businesses[0].guarantors[0]))
      const yearToRemove = 2017
      const beforeLength = entity.cashflowData.filter(d => d.year === yearToRemove).length
      expect(beforeLength).toBeGreaterThan(0) // Failure here indicates bad test data
      CacheUtil.removeCashflowDataByYear(entity, yearToRemove)
      const afterLength = entity.cashflowData.filter(d => d.year === yearToRemove).length
      expect(afterLength).toEqual(0)
    })
    it('should remove all of an entity\'s cashflow data for the specified year except any that fall into the excluded categories', () => {
      const entity = JSON.parse(JSON.stringify(loan.businesses[0].guarantors[0]))
      const yearToRemove = 2017
      const excludedCategories = ['wage_income']
      const beforeLength = entity.cashflowData.filter(d => d.year === yearToRemove).length
      const lengthInCategory = entity.cashflowData.filter(d => d.year === yearToRemove && excludedCategories.includes(d.category)).length
      expect(beforeLength).toBeGreaterThan(0) // Failure here indicates bad test data
      CacheUtil.removeCashflowDataByYear(entity, yearToRemove, excludedCategories)
      const afterLength = entity.cashflowData.filter(d => d.year === yearToRemove && excludedCategories.includes(d.category)).length
      expect(afterLength).toEqual(lengthInCategory)
    })
  })
  describe('getApplicableYears', () => {
    it('should return the OC\'s applicable years', () => {
      const expectedApplicableYears = loan.businesses[0].applicableYears
      const applicableYears = CacheUtil.getApplicableYears(loan)
      for (const year of expectedApplicableYears) {
        expect(applicableYears.indexOf(year)).toBeGreaterThan(-1)
      }
    })
  })
  describe('replaceFiscalYear', () => {
    it('should replace an entity\'s fiscal year with the given fiscal year (by rid)', () => {
      const entity = JSON.parse(JSON.stringify(loan.businesses[0]))
      // Original fiscal year had a period of 'interim'. We change it to 'tax'
      const fiscalYear = {
        rid: 289,
        year: 2017,
        days: 365,
        period: 'tax',
        isFullYear: true,
        isLeapYear: false,
        annualizationCoefficient: 1,
        __typename: 'FiscalYear'
      }
      CacheUtil.replaceFiscalYear(entity, fiscalYear)
      const newFiscalYear = entity.fiscalYears.find(fy => fy.rid === fiscalYear.rid)
      expect(newFiscalYear.period).toEqual('tax')
    })
  })
})
